import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCopy = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 13,
	height: 16,
	viewBox: "0 0 13 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.625 13.7305C3.3125 13.7305 3.04688 13.6211 2.82812 13.4023C2.60938 13.1836 2.5 12.918 2.5 12.6055V2.10547C2.5 1.79297 2.60938 1.52734 2.82812 1.30859C3.04688 1.08984 3.3125 0.980469 3.625 0.980469H11.875C12.1875 0.980469 12.4531 1.08984 12.6719 1.30859C12.8906 1.52734 13 1.79297 13 2.10547V12.6055C13 12.918 12.8906 13.1836 12.6719 13.4023C12.4531 13.6211 12.1875 13.7305 11.875 13.7305H3.625ZM3.625 12.6055H11.875V2.10547H3.625V12.6055ZM1.375 15.9805C1.0625 15.9805 0.796875 15.8711 0.578125 15.6523C0.359375 15.4336 0.25 15.168 0.25 14.8555V4.11172C0.25 3.94922 0.303125 3.81484 0.409375 3.70859C0.515625 3.60234 0.65 3.54922 0.8125 3.54922C0.975 3.54922 1.10937 3.60234 1.21562 3.70859C1.32187 3.81484 1.375 3.94922 1.375 4.11172V14.8555H9.7C9.8625 14.8555 9.99688 14.9086 10.1031 15.0148C10.2094 15.1211 10.2625 15.2555 10.2625 15.418C10.2625 15.5805 10.2094 15.7148 10.1031 15.8211C9.99688 15.9273 9.8625 15.9805 9.7 15.9805H1.375ZM3.625 2.10547V12.6055V2.10547Z",
		fill: "#1D1D1D"
	})
});
export default SvgCopy;
